import * as yup from 'yup';

export type Values = {
  notes: string | null | undefined;
};

export const validationSchema = yup.object({
  notes: yup.string().label('Notes').nullable(),
});
